import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUserId } from "../Login/loginSlice";
import storageApi from "../../api/storageApi";
import FileManager from "../AssistFile/AssstFile";
import "./Storage.css";
import ToggleSwitchStorageUse from "./ToggleSwitch";
import { IoMdArrowBack } from "react-icons/io";
import { Navigate, useNavigate } from "react-router-dom";
import useFeatures from "../../hooks/useFeatures";

const Storage = () => {
    const userId = useSelector(selectUserId);
    const { canUseStorage, hasSubscription, planType, loading: featuresLoading, loadFeatures } = useFeatures();
    const [storages, setStorages] = useState([]);
    const [selectedStorage, setSelectedStorage] = useState(null);
    const [newStorageName, setNewStorageName] = useState("");
    const [renameMap, setRenameMap] = useState({});
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [openSettingsFor, setOpenSettingsFor] = useState(null);
    const navigate = useNavigate();

    // Загружаем features
    useEffect(() => {
        loadFeatures();
    }, [loadFeatures]);

    const fetchStorages = async (uid) => {
        const res = await storageApi.getUserStorages(uid);
        if (res?.data?.success) setStorages(res.data.storages);
    };

    useEffect(() => {
        if (userId) fetchStorages(userId);
    }, [userId]);

    const handleCreateStorage = async () => {
        if (!newStorageName || !userId) return;
        await storageApi.createStorage(newStorageName, userId);
        setNewStorageName("");
        setShowCreateModal(false);
        fetchStorages(userId);
    };

    const handleDelete = async (storageId) => {
        await storageApi.deleteStorage(storageId, userId);
        if (selectedStorage === storageId) setSelectedStorage(null);
        fetchStorages(userId);
    };

    const handleRename = async (storageId) => {
        const newName = renameMap[storageId];
        if (newName) {
            await storageApi.updateStorage(storageId, userId, newName);
            setRenameMap((prev) => ({ ...prev, [storageId]: "" }));
            setOpenSettingsFor(null);
            fetchStorages(userId);
        }
    };

    const handleUpgradeClick = () => {
        navigate('/subscription');
    };

    if (!userId) return <div>Загрузка пользователя...</div>;

    // Показываем загрузку пока features грузятся
    if (featuresLoading) {
        return <div className="storage-loading">Загрузка...</div>;
    }

    // Если нет доступа к хранилищу
    if (!canUseStorage) {
        return (
            <div className="storage-page">
                <button className="back-button" onClick={() => navigate('/chat')}>
                    <IoMdArrowBack className="back-icon" />
                </button>
                <div className="storage-container">
                    <div className="storage-locked">
                        <h2>Хранилище файлов</h2>
                        <p className="storage-locked-text">
                            {!hasSubscription
                                ? "Для использования хранилища файлов необходима подписка"
                                : planType === 'standard'
                                    ? "Хранилище файлов недоступно"
                                    : "Для использования хранилища файлов необходима подписка"
                            }
                        </p>
                        <p className="storage-locked-features">
                            Хранилище позволяет загружать до 1000 файлов (до 1500 МБ) для анализа в чате
                        </p>
                        <button className="storage-upgrade-btn" onClick={handleUpgradeClick}>
                            Перейти к подпискам
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="storage-page">
            <button className="back-button" onClick={() => navigate('/chat')}>
                <IoMdArrowBack className="back-icon" />
            </button>
            {showCreateModal && (
                <div className="storage-modal-overlay">
                    <div className="storage-modal">
                        <h3>Новое хранилище</h3>
                        <input
                            value={newStorageName}
                            onChange={(e) => setNewStorageName(e.target.value)}
                            placeholder="Название хранилища"
                        />
                        <div>
                            <button onClick={handleCreateStorage}>Создать</button>
                            <button onClick={() => setShowCreateModal(false)}>Отмена</button>
                        </div>
                    </div>
                </div>
            )}

            <div className="storage-container">
                <div className="cntr_switch_storage">
                    {storages.length > 0 && (
                        <div className="cntr_switch_storage">
                            <ToggleSwitchStorageUse />
                        </div>
                    )}
                </div>
                <h2>Хранилище</h2>
                {storages.length === 0 && <button className="createButton" onClick={() => setShowCreateModal(true)}>Создать хранилище</button>}

                <ul className="storage-list">
                    {storages.map((s) => (
                        <li key={s.id}>
                            <div className="storage-item-main">
                                <span
                                    className="store_item"
                                    onClick={() => setSelectedStorage(s.id)}
                                    style={{
                                        fontWeight: selectedStorage === s.id ? "bold" : "normal",
                                    }}
                                >
                                    {s.name}
                                </span>
                                <span
                                    style={{ cursor: "pointer", marginLeft: "10px" }}
                                    onClick={() =>
                                        setOpenSettingsFor(openSettingsFor === s.id ? null : s.id)
                                    }
                                >
                                    ⚙️
                                </span>
                            </div>

                            {openSettingsFor === s.id && (
                                <div className="storage-item-actions">
                                    <input
                                        className="storage_input_actions"
                                        placeholder="Новое имя"
                                        value={renameMap[s.id] || ""}
                                        onChange={(e) =>
                                            setRenameMap((prev) => ({
                                                ...prev,
                                                [s.id]: e.target.value,
                                            }))
                                        }
                                    />
                                    <button className="settingsButton" onClick={() => handleRename(s.id)}>Переименовать</button>
                                    <button className="settingsButton" onClick={() => handleDelete(s.id)}>Удалить</button>
                                </div>
                            )}
                        </li>
                    ))}
                </ul>

                {selectedStorage && (
                    <div className="storage-files-section">
                        <h3>Файлы в хранилище</h3>
                        <FileManager storageId={selectedStorage} userId={userId} />
                    </div>
                )}
            </div>
        </div>
    );
};

export default Storage;
